export default "/images/close.svg?2836959381e113645af106fbd8ad75a5";